export const OTHER = 'Other'
export const TRACKING_TOKEN = '{tracking}'

export interface CarrierUrls {
  website: string
  trackingUrl?: string
}

export type CarrierUrlMap = Record<string, CarrierUrls>

export function trackingUrlFor(
  carriers: CarrierUrlMap,
  carrier: string,
  trackingNumber?: string | null,
): string {
  const { website, trackingUrl } = carriers[carrier] ?? {}
  const number = (trackingNumber ?? '').trim()

  if (!trackingUrl || !number) return website ?? ''

  return trackingUrl.replace(TRACKING_TOKEN, encodeURIComponent(number))
}

export function isDerivedUrl(
  carriers: CarrierUrlMap,
  value: string | null | undefined,
  carrier?: string | null,
): boolean {
  const url = (value ?? '').trim()
  if (!url) return true

  const entries = carrier
    ? [carriers[carrier]].filter((entry): entry is CarrierUrls => entry != null)
    : Object.values(carriers)

  return entries.some(
    ({ website, trackingUrl }) =>
      url === website || (!!trackingUrl && url.startsWith(trackingUrl.split(TRACKING_TOKEN)[0])),
  )
}
